<template>
  <h1 class="skin-main--title f28">{{ name }}</h1>
</template>

<script lang="ts" setup>
const props = defineProps<{
  name: string
}>()
</script>

<style lang="scss" scoped>


.skin-main--title {
  margin-bottom: 3.2rem;
}

@media screen and (max-width: 760px) {
  h1 {
    font-size: 2.4rem;
    line-height: 140%;
  }
}
</style>
